import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatListModule } from "@angular/material/list";
import { FileUploadResultModalComponent } from "./components/file-upload-result-modal/file-upload-result-modal.component";
import { DownloadFileComponent } from "./download-file/download-file.component";
import { UploadFileComponent } from "./upload-file/upload-file.component";
import { FileDetailsComponent } from "./components/file-details/file-details.component";
import { OptionMenuComponent } from "./components/option-menu/option-menu.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  declarations: [
    DownloadFileComponent,
    UploadFileComponent,
    OptionMenuComponent,
    FileDetailsComponent,
    FileUploadResultModalComponent
  ],
  exports: [DownloadFileComponent, UploadFileComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    TranslateModule
  ]
})
export class DownloadUploadFileModule {}
